import { createActions } from '../../helpers/redux';

export const RenameElementTypeMetaPropertyActions = createActions({
  dismissNotices() {
    return {};
  },

  setActiveProperty(prop) {
    return {
    	prop 
    };
  },
  
  updateFormOnChange(params) {
    return {
      form: params
    };
  }
});


// WEBPACK FOOTER //
// ./src/actions/forms/renameElementTypeMetaProperty.js